import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=0b2a4797&scoped=true&"
import script from "./newDetails.vue?vue&type=script&lang=js&"
export * from "./newDetails.vue?vue&type=script&lang=js&"
import style0 from "./newDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newDetails.vue?vue&type=style&index=1&id=0b2a4797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a4797",
  null
  
)

export default component.exports